<template>
  <div class="row halloween-orders-page">
    <div class="col-xl-12 order-xl-1">
      <spinner v-show="!isLoaded"></spinner>
      <card v-show="isLoaded" card-body-classes="table-full-width" no-footer-line>
        <h4 slot="header" class="card-title">Liste des commandes</h4>
        <div slot="header" class="col-12 text-right" style="margin-bottom: 10px; margin-top: -50px">
          <input v-model="searchText" type="text" valid="true" placeholder="Recherche" @input="onSearch" class="MySearch sendMail form-control">
          <n-button  type="primary" class="btn btn-sm btn-primary" @click.native="excelExport()">
            <span><i class="fas fa-file-csv"></i></span>
          </n-button>
          <n-button  type="primary" class="btn btn-sm btn-primary" @click.native="openChooserColumnMenu()">
            <span><i class="fas fa-columns"></i></span>
          </n-button>
          <n-button v-if="!isRole('Commercial') " type="primary" class="btn btn-sm btn-primary" @click.native="addCommand()">
            <span><i class="fas fa-plus"></i></span>
          </n-button>
        </div>
        <div class="mr-4 ml-4 mb-4 halloween-grid-scroll">
          <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"></div>
          <!-- Syncfusion Table here -->
          <ejs-grid ref='commandList' id="Grid" :dataSource="tableData" :enablePersistence='false'
                    :allowReordering='true' :rowDataBound="rowDataBound" :detailTemplate ='detailTemplate'
                    :allowResizing='true'  :showColumnChooser='true'
                    :enableHover='false' @detailDataBound="detailDataBound($event)"
                    :allowSelection='true' :allowPaging="true" @dataBound="createDetailTemplate"
                    :allowSorting='true'  :searchSettings='searchOptions'
                    :allowGrouping='false'  :editSettings='editSettings'
                    :pageSettings='pageSettings'
                    :allowExcelExport='true'
                    :dataStateChange='fetchData'
                    :dataSourceChanged='dataSourceChanged'
                    class="command-datagrid">
            <e-columns>
<!--              <e-column field='id' headerText='' :visible="false" :showInColumnChooser='false' isPrimaryKey="true" textAlign='Left' width=80></e-column>-->
              <e-column field='command_number' headerText='N° Commande' isPrimaryKey="true" textAlign='Center' width=80></e-column>
              <e-column field='customer_command_number' :visible="!type_id.includes(2) " headerText='N° Client' textAlign='Left' width=80></e-column>
              <e-column field='customer' headerText='Client' textAlign='Left' width=80></e-column>
              <e-column field='final_customer' headerText='Client final' textAlign='Left' width=80></e-column>
              <e-column field='commercial' headerText='Commercial' textAlign='Left' width=100></e-column>
              <e-column field='command_date' headerText='Date de la commande' textAlign='Center' width=70></e-column>
              <e-column :visible='false' field='preparation_date' headerText='Préparation' textAlign='Center' width=70></e-column>
              <e-column :visible='false' field='departure_date' headerText='Départ' textAlign='Center' width=80></e-column>
              <e-column field='delivery_date_requested' headerText='Date demandé' textAlign='Center' width=70></e-column>
              <e-column field='urgent_button' :commands='states' :headerText='"<i title=\"Préparé\" class=\"ml-3 mr-4 fas fa-clipboard-check\"></i><i title=\"Livré\" class=\"mr-4 fas fa-thumbs-up\"></i><i title=\"Urgent\" class=\"fas fa-exclamation-triangle\"></i>"' :disableHtmlEncode="false" textAlign='Center' minWidth=100 width=100></e-column>
              <e-column field='created_at' headerText='Création' textAlign='Center' width=70></e-column>
              <e-column field='commands' :visible='!isRole("Commercial")' headerText=''  textAlign='Center' minWidth=90 width=90 :commands='commands'></e-column>
            </e-columns>
          </ejs-grid>
        </div>

        <modal :show.sync="mailModal" headerClasses="justify-content-center">
          <h4 slot="header" class="title title-up">Envoyer par mail</h4>

          <label class="input-label">Destinataire</label>
          <fg-input class="select" name="to" v-model="mailForm.to" v-validate="'required'">
            <el-select :class="errors.first('to') ? 'has-error':''" id="role" placeholder="Choisir un contact" v-model="mailForm.to" filterable>
              <el-option v-for="contact in mailContactList" :key="contact" :label="contact" :value="contact"></el-option>
            </el-select>
            <slot name="helpBlock">
              <div class="text-danger invalid-feedback" style="display: block" :class="'mt-2'" v-if="errors.first('to')">
                {{ errors.first('to') }}
              </div>
            </slot>
          </fg-input>
          <label class="input-label">Objet</label>
          <fg-input placeholder="ex: Commande 'M4 Clé' urgente !"
                    autocomplete="off" name="object" v-validate="'required'"
                    :error="errors.first('object')"
                    v-model="mailForm.object"
                    addon-left-icon="now-ui-icons shopping_tag-content">
          </fg-input>
          <label class="input-label">Corp du message</label>
          <fg-input name="body" v-model="mailForm.body" v-validate="'required'" :error="errors.first('body')">
            <textarea class="form-group input-group resizing" id="mailBody" name="mailBody"
                      v-model="mailForm.body" rows="4" maxlength="255"
                      placeholder="">
            </textarea>
          </fg-input>

          <template slot="footer">
            <n-button type="primary" class="btn btn-sm btn-primary text-center" @click.native="sendMailButton()"><span><i class="fas fa-paper-plane"></i></span></n-button>
          </template>
        </modal>
      </card>
    </div>
    <div v-if="halloweenThemeEnabled" class="halloween-orders-decor" aria-hidden="true">
      <img class="halloween-footer-banner" :src="halloweenFooterUrl" alt="">
      <img class="halloween-footer-witch" :src="halloweenWitchUrl" alt="">
      <img class="halloween-footer-skeleton" :src="halloweenSkeletonUrl" alt="">
    </div>
  </div>
</template>

<script>
import {
  ColumnChooser,
  CommandColumn,
  DetailRow,
  Edit,
  ExcelExport,
  Filter,
  Group,
  Page,
  Reorder,
  Resize,
  Search,
  Sort
} from "@syncfusion/ej2-vue-grids";
import detailTemplate from "./detailTemplate";
import moment from "moment";
import swal from "sweetalert2";
import Spinner from "src/components/Spinner/Circle";
import {Modal} from 'src/components'
import {Option, Select} from 'element-ui'
import Authorizable from '@/mixins/authorizable'
import halloweenTheme from '@/mixins/halloweenTheme'
import halloweenFooterUrl from '@/assets/img/halloween/dashboard-footer-strip.png'
import halloweenWitchUrl from '@/assets/img/halloween/witch-cauldron.png'
import halloweenSkeletonUrl from '@/assets/img/halloween/skeleton-orders.png'
import $ from 'jquery'

export default {
  name: "CommandList",
  mixins: [Authorizable, halloweenTheme],
  components: {
    Spinner,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      halloweenFooterUrl,
      halloweenWitchUrl,
      halloweenSkeletonUrl,

      selectedRow: null,
      commandStateUpdates: {},

      searchTimeOut: 0,
      searchText: '',

      modal: Modal,
      type_id: [],
      filter: 'none',
      commandList: [],
      count: 0,
      deviceList: [],
      mailModal: false,
      mailForm: {
        command_id: '',
        to: '',
        object: '',
        body: ''
      },
      mailContactList: [
        'a.belrhazi@ec2e.com',
        'b.gaulupeau@ec2e.com',
        'g.badeau@ec2e.com',
        'j.mouty@ec2e.com',
        'j.martinez@ec2e.com',
        's.guillemoteau@ec2e.com',
        'm.lamy@ec2e.com',
        'c.haller@ec2e.com',
      ],
      isLoaded: false,
      tableData: [],
      editSettings: { allowEditing: false, allowDeleting: true },
      commands: [
        { buttonOption: { cssClass: 'e-flat', iconCss: 'e-icons', click: this.editButton} },
        { buttonOption: { cssClass: 'e-flat', iconCss: 'e-icons', click: this.prepareButton} },
        { buttonOption: { cssClass: 'e-flat', iconCss: 'e-icons', click: this.actionPopup } },
      ],
      states: [
        { buttonOption: { cssClass: 'e-flat', iconCss: 'e-icons', click: this.preparationDatetButton} },
        { buttonOption: { cssClass: 'e-flat', iconCss: 'e-icons', click: this.departureDateButton} },
        { buttonOption: { cssClass: 'e-flat', iconCss: 'e-icons', click: this.urgentButton} }
      ],
      detailTemplate: function () {
        return { template :detailTemplate }
      },
      searchOptions: {fields: ['command_number', 'customer_command_number', 'detailTemplate', 'customer']},
      pageSettings: { pageSize: 15, pageSizes:  ['15','25','50', '100', '250','All'], pageCount: 4 },
      start: null,
      step_1: null,
      step_2: null,
      step_3: null,

      isDuplicating: false
    };
  },
  provide: {
    grid: [Page, Search, Sort, Filter, Group, ExcelExport, DetailRow, ColumnChooser, Resize, Reorder, Edit, CommandColumn]
  }, 
  watch: {
    '$route.path'(newValue, oldValue) {
      this.isLoaded = false
      this.tableData = []
      this.filter = 'none'

      if(newValue.includes('commands') && oldValue.includes('commands')){
        if(localStorage.getItem('commandList') !== null){
          var model = (localStorage.getItem('commandList'))
          var modelParsed = JSON.parse(model);
          modelParsed.searchText = ''
          localStorage.setItem('commandList', (JSON.stringify(modelParsed)));
        }
      }

      this.searchText = ''

      this.init_component();
    }
  },
  mounted() {
    this.init_component();
    this.start = moment();
  },
  beforeDestroy(){
    if(this.searchTimeOut){
      clearTimeout(this.searchTimeOut)
    }

    EventBus.$off('commandStateUpdate')
    EventBus.$off('getCommandList')
    EventBus.$off('updateDeviceList')
    EventBus.$off('filterUpdate')

    // Sauvegarde la configuration du tableau dans le localStorage
    var grid = this.$refs.commandList.ej2Instances;
    localStorage.setItem('commandList', (JSON.stringify({... JSON.parse(grid.getPersistData()), filter: this.filter, searchText: this.searchText})));
  },
  methods: {
    actionPopup(args){
      if(!this.isDuplicating){
        var rowEle = $(args.target).parents('.e-row')
        var rowIndex = parseInt(rowEle[0].getAttribute('aria-rowindex'))

        this.$refs.commandList.selectRow(rowIndex)

        this.selectedRowArgs = args

        var elements = document.getElementsByClassName('actionPopup');

        if(elements[rowIndex].style.display === 'block'){
          elements[rowIndex].style.display = 'none'
        } else  {
          elements[rowIndex].style.display = 'block'
        }
      }
    },
    // Initialise le composant, celui-ci peut être réinitialisé si on change de route en gardant ce composant actif
    init_component(){
      let syncFus = this.$refs.commandList

      localStorage.setItem('lastURL', this.$route.name)

      // Le composant peut être réinitialisé sans être détruit lors d'un changement
      // de route interne. On retire donc les anciens listeners avant de les recréer.
      EventBus.$off('commandStateUpdate')
      EventBus.$off('getCommandList')
      EventBus.$off('updateDeviceList')
      EventBus.$off('filterUpdate')

      EventBus.$on('commandStateUpdate', args => {
        var selectedRow = syncFus.ej2Instances.getCurrentViewRecords().find(command => command.id === args.commandId)
        if(selectedRow === undefined) return

        var rowData = this.applyCommandStateToRow({...selectedRow}, args.state)

        this.updateGridCommandRow(rowData)

        if(args.state !== 'half-prepared'){
          this.persistCommandState(args.commandId, args.state)
        }

      });
      EventBus.$on('getCommandList', args => {
        EventBus.$emit('setCommandList', this.tableData)
        EventBus.$emit('setDeviceList', this.deviceList)
      });
      EventBus.$on( 'updateDeviceList', args =>{
        var updateDeviceList = new Promise((resolve, reject) => {
          args.forEach( (subscription, index, array) => {
            var alreadyExist = false;
            if(this.deviceList[subscription['device_id']].subscription!== null){
              this.deviceList[subscription['device_id']].subscription.forEach(DeviceSubscription =>{
                if (DeviceSubscription['id'] === subscription['id']){
                  alreadyExist = true
                }
              })
            }

            if(alreadyExist === false) {
              if(this.deviceList[subscription['device_id']].subscription !== null){
                this.deviceList[subscription['device_id']].subscription.push(subscription)
              } else {
                this.deviceList[subscription['device_id']].subscription = [subscription]
              }
            }
            if (index === array.length -1) resolve();
          })
        })
        updateDeviceList.then(() => {
          EventBus.$emit('setDeviceList', this.deviceList)
        });
      });
      EventBus.$on( 'filterUpdate', args => {

        var grid = this.$refs['commandList'].ej2Instances;
        grid.pageSettings.currentPage = 1

        if(this.filter !== this.$route.params.filter){
          this.filter = this.$route.params.filter

          this.fetchData({ skip: 0, take: 15 })
        }
      });

      this.getPersistentSettings('commandList')
    },
    // Génère-les detailTemplate pour toutes les lignes de SyncFusion
    createDetailTemplate(){
      // this.$refs.commandList.detailExpandAll()
      // this.$refs.commandList.detailCollapseAll()

      $('.mail-button').off('click.commandList').on('click.commandList', (evt) => {
        this.openMailModalButton(this.selectedRowArgs)
      })

      $('.duplicate-button').off('click.commandList').on('click.commandList', (evt) => {
        this.duplicateButton(this.selectedRowArgs)
      })

      $('.remove-button').off('click.commandList').on('click.commandList', (evt) => {
        this.deleteButton(this.selectedRowArgs)
      })

      $('.cancel-button').off('click.commandList').on('click.commandList', (evt) => {
        this.cancelButton(this.selectedRowArgs)
      })
    },

    onSearch(event){
      this.searchText = event.target.value

      if (this.searchTimeOut) {
        clearTimeout(this.searchTimeOut)
      }

      this.searchTimeOut = setTimeout(this.search, 1000)
    },
    // Permet de faire une recherche dans le tableau
    search: function() {
      this.fetchData({ skip: 0, take: 15 })
      // this.$refs.commandList.search(searchText);
    },
    // Permet d'exporter le résultat dans un tableur
    excelExport: function(args) {
      this.$refs.commandList.excelExport();
    },
    // Permet de récupérer dans le localStorage la configuration du tableau
    getPersistentSettings(ref){
      if(localStorage.getItem(ref) !== null){
        var grid = this.$refs[ref].ej2Instances;

        var model = (localStorage.getItem(ref))
        var modelParsed = JSON.parse(model);

        var newColumns= [];
        var cookieColumns = modelParsed.columns;
        var actualColumns = grid.columns;

        cookieColumns.forEach(cookieColumn => {
          actualColumns.forEach(actualColumn => {
            if(actualColumn.index == cookieColumn.index){
              actualColumn.visible = cookieColumn.visible;
              newColumns.push(actualColumn)
            }
          })
        })

        grid.columns = newColumns;
        grid.sortSettings = modelParsed.sortSettings;
        grid.pageSettings = modelParsed.pageSettings;
        grid.pageSettings.currentPage = modelParsed.pageSettings.currentPage
        this.filter = modelParsed.filter

        this.searchText = modelParsed.searchText !== undefined ?  modelParsed.searchText : ''

        this.getTypeFromRoute(this.$route.matched)
      } else {
        this.getTypeFromRoute(this.$route.matched)
      }

    },
    // Permet de remplir le tableau
    fetchData(state){
      if(this.$route.params.filter !== undefined){
        this.filter = this.$route.params.filter
      }
      this.axios.get(process.env.VUE_APP_API_BASE_URL+`command/list`, {
        params: {
          type: this.type_id,
          state : state,
          filter: this.filter,
          search: this.searchText
        }
      }).catch(error => {

      }).then( response => {

        this.commandList = response.data['commandList'];
        this.count = response.data['count'];

        var fillCommandList = new Promise((resolve, rejected) => {
          this.commandList.forEach( (data, index, array) =>{
            data.created_at = moment(data.created_at).format('DD/MM/YYYY')
            data.command_date = moment(data.command_date).format('DD/MM/YYYY')

            data.departure_date !== null ? data.departure_date = moment(data.departure_date).format('DD/MM/YYYY') : null
            data.preparation_date !== null ? data.preparation_date = moment(data.preparation_date).format('DD/MM/YYYY') : null
            data.delivery_date_requested !== null ? data.delivery_date_requested = moment(data.delivery_date_requested).format('DD/MM/YYYY') : null

            var CommandDeliver = 0
            var CommandPrepared = 0
            var CommandStandBy = 0
            var CommandSubContract = 0

            data.items.forEach(item => {
              if(item.pivot.departure_date !== false && item.pivot.departure_date !== null){
                CommandDeliver++
              }

              if(item.pivot.standby_date !== false && item.pivot.standby_date !== null){
                CommandStandBy++
              }

              if(item.pivot.subcontract_date !== false && item.pivot.subcontract_date !== null){
                CommandSubContract++
              }

              if(item.pivot.preparation_date !== false && item.pivot.preparation_date !== null){
                CommandPrepared++
              }
            })

            if(CommandDeliver === data.items.length){
              data.status = 'deliver'
            } else if(CommandPrepared === data.items.length) {
              data.status = 'prepared'
            } else if(CommandStandBy > 0) {
              data.status = 'standby'
            } else if(CommandSubContract > 0) {
              data.status = 'subcontract'
            } else if(data.status === 'half-prepared'){
              data.status = 'half-prepared'
            } else {
              data.status = 'todo'
            }
            if(data.status !== 'deliver' && data.status !== 'prepared'  && data.urgent === 1){
              data.status = 'urgent'
            }

            if(index === array.length - 1) resolve();
          })
          if(this.commandList.length === 0) resolve();
        })

        fillCommandList.then((response) => {
          this.step_1 = this.start.diff(moment())
          this.fillTableData()
        })

        this.deviceList = response.data['deviceList'];

      })
    },

    fillTableData(){
      var tableData = []
      var fillTableData = new Promise((resolve, rejected) => {
        if(this.filter === 'none'){
          tableData = [...this.commandList]
          resolve();
        } else {
          this.commandList.forEach((command, index, array) => {
            if(this.filter === 'todo'){
              if(command.status === 'todo' || command.status === 'urgent' || command.status === 'half-prepared'){
                tableData.push(command)
              } else {
                console.log('Filtre: to do')
                console.log('Ejected from table ', command)
              }
            } else {
              if(command.status === this.filter){
                tableData.push(command)
              } else {
                console.log('Filtre: '+this.filter)
                console.log('Ejected from table ', command)
              }
            }

            if(index === array.length - 1) resolve();
          })
        }
      })
      fillTableData.then((response) => {
        this.step_2 = this.start.diff(moment())

        var result = {'d': { 'results': tableData, '__count': this.count }}
        this.tableData =  { result: result['d']['results'], count: parseInt(result['d']['__count'], 10) };

            if(localStorage.getItem('commandList') !== null) {
              let grid = this.$refs['commandList'].ej2Instances;

              let model = (localStorage.getItem('commandList'))
              let modelParsed = JSON.parse(model);
              
              grid.pageSettings.currentPage = modelParsed.pageSettings.currentPage

              localStorage.removeItem("commandList");
            }

        this.isLoaded =  true
      })

    },
    // Se déclenche lorsqu'une ligne est déroulée, actuellement utilisé pour un Fix CSS
    detailDataBound: function($event){
       $event.detailElement.colSpan = $event.detailElement.colSpan+1
    },
    applyCommandRowStatusStyle(row, data){
      row.style.opacity = data.canceled === 1 ? 0.5 : ''
      row.classList.toggle('half-prepared', data.status === 'half-prepared')

      if(data.canceled === 1){
        row.style.backgroundColor = '#e0e0e0'
      } else if(data.status === 'deliver'){
        row.style.backgroundColor = 'rgb(162, 245, 191)'
      } else if(data.status === 'prepared') {
        row.style.backgroundColor = '#92c9f9'
      } else if(data.status === 'standby') {
        row.style.backgroundColor = '#ff8d0075'
      } else if(data.status === 'subcontract'){
        row.style.backgroundColor = 'rgba(217,3,104,0.50)'
      } else if(data.status === 'urgent'){
        row.style.backgroundColor = '#f9acaa'
      } else {
        row.style.backgroundColor = '#ffffff00'
      }
    },
    // Parcour toutes les lignes du tableau lorsque celui-ci est rempli
    rowDataBound: function (args){
      this.applyCommandRowStatusStyle(args.row, args.data)

      var stateColumnIndex = parseInt(this.$refs.commandList.getColumnHeaderByField('urgent_button').ariaColIndex)+1

      if(args.data.preparation_date !== null){
        args.row.cells[stateColumnIndex].firstElementChild.children[0].firstElementChild.classList = "e-btn-icon far fa-check-square e-icons"
        args.row.cells[stateColumnIndex].firstElementChild.children[0].title = "Préparé le "+args.data.preparation_date
      } else {
        args.row.cells[stateColumnIndex].firstElementChild.children[0].firstElementChild.classList = "e-btn-icon far fa-square e-icons"
        args.row.cells[stateColumnIndex].firstElementChild.children[0].title = "A préparer"
      }
      if(this.isCommercial()){
        args.row.cells[stateColumnIndex].firstElementChild.children[0].firstElementChild.classList.add('square-disabled')
      }

      if(args.data.departure_date !== null){
        args.row.cells[stateColumnIndex].firstElementChild.children[1].firstElementChild.classList = "e-btn-icon far fa-check-square e-icons"
        args.row.cells[stateColumnIndex].firstElementChild.children[1].title = "Livré le "+args.data.departure_date
      } else {
        args.row.cells[stateColumnIndex].firstElementChild.children[1].firstElementChild.classList = "e-btn-icon far fa-square e-icons"
        args.row.cells[stateColumnIndex].firstElementChild.children[1].title = "A livrer"
      }
      if(this.isCommercial()){
        args.row.cells[stateColumnIndex].firstElementChild.children[1].firstElementChild.classList.add('square-disabled')
      }

      args.row.cells[stateColumnIndex].firstElementChild.children[2].title = "Urgent "
      if( args.data.urgent === 1){
        args.row.cells[stateColumnIndex].firstElementChild.children[2].firstElementChild.classList = "e-btn-icon far fa-check-square e-icons"
      } else {
        args.row.cells[stateColumnIndex].firstElementChild.children[2].firstElementChild.classList = "e-btn-icon far fa-square e-icons"
      }
      if(this.isCommercial()){
        args.row.cells[stateColumnIndex].firstElementChild.children[2].firstElementChild.classList.add('square-disabled')
      }

      var commandsColumnIndex = parseInt(this.$refs.commandList.getColumnHeaderByField('commands').ariaColIndex)+1

      args.row.cells[commandsColumnIndex].firstElementChild.children[0].title = "Éditer la commande"
      args.row.cells[commandsColumnIndex].firstElementChild.children[0].classList = "e-lib e-btn e-control e-flat e-icon-btn fas fa-edit"
      args.row.cells[commandsColumnIndex].firstElementChild.children[0].removeChild(args.row.cells[commandsColumnIndex].firstElementChild.children[0].firstElementChild)

      args.row.cells[commandsColumnIndex].firstElementChild.children[1].title = "Préparer la commande"
      args.row.cells[commandsColumnIndex].firstElementChild.children[1].classList = "e-lib e-btn e-control e-flat e-icon-btn fas fa-tools"
      args.row.cells[commandsColumnIndex].firstElementChild.children[1].removeChild(args.row.cells[commandsColumnIndex].firstElementChild.children[1].firstElementChild)

      args.row.cells[commandsColumnIndex].firstElementChild.children[2].title = "Liste des actions"
      args.row.cells[commandsColumnIndex].firstElementChild.children[2].classList = "e-lib e-btn e-control e-flat e-icon-btn fas fa-ellipsis-h"
      args.row.cells[commandsColumnIndex].firstElementChild.children[2].removeChild(args.row.cells[commandsColumnIndex].firstElementChild.children[2].firstElementChild)

      if(args.data.canceled === 1){
        args.row.cells[stateColumnIndex].firstElementChild.children[0].disabled = true;
        args.row.cells[stateColumnIndex].firstElementChild.children[1].disabled = true;
        args.row.cells[stateColumnIndex].firstElementChild.children[2].disabled = true;

        args.row.cells[commandsColumnIndex].firstElementChild.children[0].disabled = true;
        args.row.cells[commandsColumnIndex].firstElementChild.children[1].disabled = true;
        args.row.cells[commandsColumnIndex].firstElementChild.children[2].disabled = true;
      }

      var newDiv = document.createElement("div")
      args.row.cells[commandsColumnIndex].firstElementChild.append(newDiv)
     
      args.row.cells[commandsColumnIndex].firstElementChild.children[2].innerHTML = '' +
          '<div class="actionPopup">' +
            '<ul class="actionList">' +
              '<button type="button" title="Envoyer par Mail" class="e-lib e-btn e-control e-flat e-icon-btn fas fa-envelope mail-button" style="display: inline-flex; float: left">' +
                '<div style="margin-left:7px; font-family: Roboto">Mail</div>' +
              '</button><br/>' +
              '<button type="button" title="dupliquer la commande" class="e-lib e-btn e-control e-flat e-icon-btn fas fa-copy duplicate-button" style="display: inline-flex; float: left">' +
                '<div style="margin-left:7px; font-family: Roboto">dupliquer</div>' +
              '</button><br/>' +
              '<button type="button" title="Supprimer la commande" class="e-lib e-btn e-control e-flat e-icon-btn fas fa-trash-alt remove-button" style="display: inline-flex; float: left">' +
                '<div style="margin-left:7px; font-family: Roboto">Supprimer</div>' +
              '</button><br/>' +
              '<button type="button" title="Annuler la commande" class="e-lib e-btn e-control e-flat e-icon-btn fas fa-times cancel-button" style="display: inline-flex; float: left">' +
                '<div style="margin-left:7px; font-family: Roboto">Annuler</div>' +
              '</button>' +
            '</ul>' +
          '</div>'

      if(window.App.role === 'Commercial'){
        args.row.cells[commandsColumnIndex].innerHTML = ''
      }
    },
    // Retourne 'true' si l'utilisateur connecté est un commercial
    isCommercial(){
      return window.App.role === 'Commercial'
    },
    // Redirige vers le formulaire d'ajout de commande
    addCommand(){
      this.$router.push({ name: 'Command Form' })
    },
    // Redirige vers le formulaire d'édition de commande
    editButton: function(args){
      var rowEle = $(args.target).parents('.e-row')
      var rowIndex = parseInt(rowEle[0].getAttribute('aria-rowindex'))
      this.$refs.commandList.selectRow(rowIndex)
      var rowData = this.$refs.commandList.getSelectedRecords()[0]

      // if(!this.can('update_device')){
      //   this.$router.push({ name: 'Command Device Form', params: {command: rowData} })
      // } else {
        this.$router.push({ name: 'Command Form', params: {command: rowData} })
      // }
    },
    // Redirige vers le formulaire de préparation de commande
    prepareButton: function(args) {
      var rowEle = $(args.target).parents('.e-row')
      var rowIndex = parseInt(rowEle[0].getAttribute('aria-rowindex'))
      this.$refs.commandList.selectRow(rowIndex)
      var rowData = this.$refs.commandList.getSelectedRecords()[0]

      this.$router.push({ name: 'Command Device Form', params: {command: rowData} })
    },
    // Change l'état 'Urgent' de la commande en Urgent (Axios) et change la couleur de la ligne en conséquence
    urgentButton: function (args){
      if(window.App.role !== 'Commercial') {
        var rowEle = $(args.target).parents('.e-row')
        var rowIndex = parseInt(rowEle[0].getAttribute('aria-rowindex'))
        var rowContainerIndex = rowIndex
        this.$refs.commandList.selectRow(rowIndex)
        var rowData = {...this.$refs.commandList.getSelectedRecords()[0]}

        var stateColumnIndex = parseInt(this.$refs.commandList.getColumnHeaderByField('urgent_button').ariaColIndex) + 1
        var rowsContainer = this.$refs.commandList.$el.children[6].firstElementChild.firstElementChild.children[1]
        var row = rowsContainer.children[rowContainerIndex]

        if (rowData.urgent === 1) {
          rowData.urgent = 0
          EventBus.$emit('commandUrgent' + rowData.id, 0)
          row.cells[stateColumnIndex].firstElementChild.children[2].firstElementChild.classList = "e-btn-icon far fa-square e-urgent e-icons"
          if (row.style.backgroundColor !== 'rgb(162, 245, 191)' && row.style.backgroundColor !== 'rgb(146, 201, 249)') {
            var CommandStandBy = 0

            rowData.items.forEach(item => {
              if (item.pivot.standby_date !== false && item.pivot.standby_date !== null) {
                CommandStandBy++
              }
            })
            if (CommandStandBy > 0) {
              row.style.backgroundColor = '#ff8d0075'
              rowData.status = 'standby'
            } else {
              row.style.backgroundColor = '#ffffff00'
              rowData.status = 'todo'
            }
          }
        } else {
          rowData.urgent = 1
          EventBus.$emit('commandUrgent' + rowData.id, 1)
          row.cells[stateColumnIndex].firstElementChild.children[2].firstElementChild.classList = "e-btn-icon far fa-check-square e-urgent e-icons"
          if (row.style.backgroundColor !== 'rgb(162, 245, 191)' && row.style.backgroundColor !== 'rgb(146, 201, 249)') {
            row.style.backgroundColor = '#f9acaa'
          }
          if (rowData.status !== 'deliver' && rowData.status !== 'prepared') {
            rowData.status = 'urgent'
          }
        }
        this.$refs.commandList.updateRow(rowIndex, rowData);

        this.axios.get(process.env.VUE_APP_API_BASE_URL + `command/state/update`, {
          params: {
            command_id: rowData.id,
            state: rowData.urgent === 1 ? 'urgent' : 'not urgent',
          }
        }).then((response) => {
          EventBus.$emit('refreshFiltersNumbers')
        })
      }
    },
    // Supprime la commande (Axios->softDelete)
    deleteButton: function (args){
      var rowEle = $(args.target).parents('.e-row')
      var rowIndex = parseInt(rowEle[0].getAttribute('aria-rowindex'))
      this.$refs.commandList.selectRow(rowIndex)
      var rowData = this.$refs.commandList.getSelectedRecords()[0]

      swal.fire({
        title: 'Supprimer la commande "'+rowData.command_number+'" ?',
        text: 'Attention, vous ne pourrez pas revenir en arrière',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-danger btn-fill',
        cancelButtonClass: 'btn btn-secondary btn-fill',
        cancelButtonText: 'Retour',
        confirmButtonText: 'Supprimer quand même !',
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.axios.post(process.env.VUE_APP_API_BASE_URL+`command/delete/`+rowData.id).catch(error => {
            this.$notify({message: "Une erreur est survenue lors de la suppression", type: 'danger', verticalAlign: 'bottom'})
          }).then( response => {
            this.$notify({message: 'La commande '+rowData.command_number+' a bien été supprimé', type: 'success', verticalAlign: 'bottom'})
            this.$refs.commandList.deleteRecord('command_number', rowData.command_number)
            EventBus.$emit('refreshFiltersNumbers')
          })
        }
      })

    },
    // Passe la commande au status "Annulé"
    cancelButton: function(args){
      var rowEle = $(args.target).parents('.e-row')
      var rowIndex = parseInt(rowEle[0].getAttribute('aria-rowindex'))
      this.$refs.commandList.selectRow(rowIndex)
      var rowData = this.$refs.commandList.getSelectedRecords()[0]

      swal.fire({
        title: 'Annuler la commande "'+rowData.command_number+'" ?',
        text: 'Attention, vous ne pourrez pas revenir en arrière',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-danger btn-fill',
        cancelButtonClass: 'btn btn-secondary btn-fill',
        cancelButtonText: 'Retour',
        confirmButtonText: 'Annuler quand même !',
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.axios.post(process.env.VUE_APP_API_BASE_URL+`command/cancel/`+rowData.id).catch(error => {
            this.$notify({message: "Une erreur est survenue lors de l'annulation", type: 'danger', verticalAlign: 'bottom'})
          }).then( response => {
            this.$notify({message: 'La commande '+rowData.command_number+' a bien été annulé', type: 'success', verticalAlign: 'bottom'})
            rowData.canceled = 1
            this.$refs.commandList.updateRow(rowIndex, rowData);
            EventBus.$emit('refreshFiltersNumbers')
          })
        }
      })
    },
    // Ouvre la modale qui permet d'envoyer la commande par mail à un collaborateur
    openMailModalButton: function(args){
      var rowEle = $(args.target).parents('.e-row')
      var rowIndex = parseInt(rowEle[0].getAttribute('aria-rowindex'))
      this.$refs.commandList.selectRow(rowIndex)
      var rowData = this.$refs.commandList.getSelectedRecords()[0]

      this.mailForm.command_id = rowData.id
      this.mailForm.object = 'La commande "'+rowData.command_number+'"'
      this.mailForm.to = ''
      this.mailForm.body = ''
      this.mailModal = true
    },
    // Permet d'envoyer la commande par mail à un collaborateur
    sendMailButton: function (){
      this.$validator.validateAll().then( value => {
        if(value === true){
          this.mailModal = false
          this.axios.get(process.env.VUE_APP_API_BASE_URL+`command/send`, {
            params: {
              id: this.mailForm.command_id,
              receiver: this.mailForm.to,
              object: this.mailForm.object,
              body: this.mailForm.body,
            }
          }).then((response) => {
            this.mailForm = {
              command_id: '',
              to: '',
              object: '',
              body: ''
            }
            this.$notify({message: 'La commande a bien été envoyée par E-mail', type: 'success', verticalAlign: 'bottom'})
          })
        }
      })
    },
    // Permet de dupliquer une commande
    duplicateButton: function(args){
      this.isDuplicating = true

      var rowEle = $(args.target).parents('.e-row')
      var rowIndex = parseInt(rowEle[0].getAttribute('aria-rowindex'))

      this.$refs.commandList.selectRow(rowIndex)
      var rowData = this.$refs.commandList.getSelectedRecords()[0]

      this.$router.push({ name: 'Command Form', params: {duplicate: rowData} })
    },
    applyCommandStateToRow(rowData, state){
      var displayDate = moment().format('DD/MM/YYYY')

      if(state === 'departure_date'){
        rowData.departure_date = displayDate
        rowData.status = 'deliver'

        if(rowData.preparation_date === null || rowData.preparation_date === false){
          rowData.preparation_date = displayDate
        }
      }

      if(state === 'half-prepared'){
        rowData.status = 'half-prepared'
      }

      if(state === 'preparation_date'){
        rowData.departure_date = null
        rowData.preparation_date = displayDate
        rowData.status = 'prepared'
      }

      if(state === 'standby_date'){
        rowData.departure_date = null
        rowData.preparation_date = null
        rowData.standby_date = displayDate
        rowData.status = rowData.urgent === 1 ? 'urgent' : 'standby'
      }

      if(state === 'subcontract_date'){
        rowData.departure_date = null
        rowData.preparation_date = null
        rowData.standby_date = null
        rowData.subcontract_date = displayDate
        rowData.status = 'subcontract'
      }

      if(state === 'todo'){
        rowData.departure_date = null
        rowData.preparation_date = null
        rowData.standby_date = null
        rowData.status = rowData.urgent === 1 ? 'urgent' : 'todo'
      }

      return rowData
    },
    persistCommandState(commandId, state){
      return this.axios.get(process.env.VUE_APP_API_BASE_URL+`command/state/update`, {
        params: {
          command_id: commandId,
          state: state,
        }
      })
    },
    isActiveItemState(value){
      return value !== null && value !== false
    },
    stateAfterRemovingPreparation(rowData){
      var items = rowData.items || []
      var hasStandbyItem = items.some(item => item.pivot && this.isActiveItemState(item.pivot.standby_date))
      var hasSubcontractItem = items.some(item => item.pivot && this.isActiveItemState(item.pivot.subcontract_date))

      if(hasStandbyItem) return 'standby_date'
      if(hasSubcontractItem) return 'subcontract_date'
      return 'todo'
    },
    buildItemStateRequests(rowData, state, enabled){
      var stateDate = moment().format('YYYY-MM-DD')
      var requests = []

      ;(rowData.items || []).forEach(item => {
        if(!item.pivot) return

        var isActive = this.isActiveItemState(item.pivot[state])
        if(isActive === enabled) return

        item.pivot[state] = enabled ? stateDate : false

        if(state === 'departure_date' && enabled && !this.isActiveItemState(item.pivot.preparation_date)){
          item.pivot.preparation_date = stateDate
        }

        requests.push(this.axios.get(process.env.VUE_APP_API_BASE_URL+`item/state/update`, {
          params: {
            item_id: item.pivot.id,
            state: state,
            '$event': enabled
          }
        }))
      })

      return requests
    },
    completeBulkStateUpdate(rowData, state, itemRequests, buttonState){
      Promise.all(itemRequests).then(() => {
        return this.persistCommandState(rowData.id, state)
      }).then(() => {
        EventBus.$emit('refreshFiltersNumbers')
      }).catch(() => {
        this.$notify({message: "Impossible de mettre à jour l'état de la commande", type: 'danger', verticalAlign: 'bottom'})

        var grid = this.$refs.commandList.ej2Instances
        var pageSize = grid.pageSettings.pageSize
        var currentPage = grid.pageSettings.currentPage
        this.fetchData({skip: (currentPage - 1) * pageSize, take: pageSize})
      }).then(() => {
        this.setCommandStateButtonLoading(rowData, buttonState, false)
        this.$delete(this.commandStateUpdates, rowData.id)
      })
    },
    updateGridCommandRow(rowData){
      var grid = this.$refs.commandList.ej2Instances
      grid.setRowData(rowData.command_number, rowData)

      var rowIndex = grid.getRowIndexByPrimaryKey(rowData.command_number)
      var row = grid.getRowByIndex(rowIndex)
      if(row) this.applyCommandRowStatusStyle(row, rowData)
    },
    setCommandStateButtonLoading(rowData, state, isLoading){
      if(!this.$refs.commandList) return

      var grid = this.$refs.commandList.ej2Instances
      var rowIndex = grid.getRowIndexByPrimaryKey(rowData.command_number)
      var row = grid.getRowByIndex(rowIndex)
      if(!row) return

      var stateColumnIndex = parseInt(this.$refs.commandList.getColumnHeaderByField('urgent_button').ariaColIndex)+1
      var buttonIndex = state === 'departure_date' ? 1 : 0
      var stateCell = row.cells[stateColumnIndex]
      var button = stateCell && stateCell.firstElementChild ? stateCell.firstElementChild.children[buttonIndex] : null
      if(!button || !button.firstElementChild) return

      var icon = button.firstElementChild
      var stateValue = state === 'departure_date' ? rowData.departure_date : rowData.preparation_date

      button.classList.toggle('command-state-loading', isLoading)

      if(isLoading){
        button.disabled = true
        button.setAttribute('aria-busy', 'true')
        button.setAttribute('aria-label', 'Mise à jour en cours')
        button.title = 'Mise à jour en cours'
        icon.className = 'e-btn-icon fas fa-circle-notch fa-spin e-icons'
        return
      }

      button.removeAttribute('aria-busy')
      button.removeAttribute('aria-label')
      button.disabled = rowData.canceled === 1 || this.isCommercial()
      button.title = this.isActiveItemState(stateValue)
        ? (state === 'departure_date' ? 'Livré le ' : 'Préparé le ') + stateValue
        : (state === 'departure_date' ? 'A livrer' : 'A préparer')
      icon.className = this.isActiveItemState(stateValue)
        ? 'e-btn-icon far fa-check-square e-icons'
        : 'e-btn-icon far fa-square e-icons'

      if(this.isCommercial()) icon.classList.add('square-disabled')
    },
    // Passer le statut de tous les articles de la commande en préparé
    preparationDatetButton: function (args){
      if(window.App.role !== 'Commercial'){
        var rowEle = $(args.target).parents('.e-row')
        var rowIndex = parseInt(rowEle[0].getAttribute('aria-rowindex'))
        this.$refs.commandList.selectRow(rowIndex)
        var rowData = {...this.$refs.commandList.getSelectedRecords()[0]}

        if(rowData.departure_date !== null && rowData.departure_date !== false){
          this.$notify({message: "Vous ne pouvez pas passer la commande en 'Non préparé' si la commande est déjà livrée", type: 'danger', verticalAlign: 'bottom'})
          return
        }

        if(this.commandStateUpdates[rowData.id]) return
        this.$set(this.commandStateUpdates, rowData.id, true)

        var shouldPrepare = !this.isActiveItemState(rowData.preparation_date)
        var itemRequests = this.buildItemStateRequests(rowData, 'preparation_date', shouldPrepare)
        var commandState = shouldPrepare ? 'preparation_date' : this.stateAfterRemovingPreparation(rowData)

        this.applyCommandStateToRow(rowData, commandState)
        this.updateGridCommandRow(rowData)
        this.setCommandStateButtonLoading(rowData, 'preparation_date', true)
        this.completeBulkStateUpdate(rowData, commandState, itemRequests, 'preparation_date')
      }
    },

    dataSourceChanged : function(state) {
      state.endEdit()
    },
    // Passer le statut de tous les articles de la commande en livré
    departureDateButton: function (args){
      if(window.App.role !== 'Commercial') {
        var rowEle = $(args.target).parents('.e-row')
        var rowIndex = parseInt(rowEle[0].getAttribute('aria-rowindex'))
        this.$refs.commandList.selectRow(rowIndex)
        var rowData = {...this.$refs.commandList.getSelectedRecords()[0]}

        if(this.commandStateUpdates[rowData.id]) return
        this.$set(this.commandStateUpdates, rowData.id, true)

        var shouldDeliver = !this.isActiveItemState(rowData.departure_date)
        var itemRequests = this.buildItemStateRequests(rowData, 'departure_date', shouldDeliver)
        var commandState = shouldDeliver ? 'departure_date' : 'preparation_date'

        this.applyCommandStateToRow(rowData, commandState)
        this.updateGridCommandRow(rowData)
        this.setCommandStateButtonLoading(rowData, 'departure_date', true)
        this.completeBulkStateUpdate(rowData, commandState, itemRequests, 'departure_date')
      }
    },
    // Ouvre la modale SyncFusion dédiée au choix des colonnes
    openChooserColumnMenu(){
      this.$refs.commandList.openColumnChooser()
    },
    // Récupère le type d'article à afficher dans le tableau (à donner à la requête axios)
    getTypeFromRoute(matchedRoutes){
      var typeList = [] // Normalement il n'y en a qu'un pour le moment (26/11/2021)

      var init_TypeList = new Promise((resolve, reject) => {
        matchedRoutes.forEach( (route, index, array) => {
          if(route.path === this.$route.path){
            if(route.props.type_id !== undefined){
              typeList =  this.arrayUnique(route.props.type_id.concat(typeList))
            }
          }
          if (index === array.length -1) resolve();
        })
      })

      init_TypeList.then(() => {
        this.type_id = typeList

        var grid = this.$refs["commandList"].ej2Instances;

        let state = { skip:  (grid.pageSettings.currentPage - 1) * grid.pageSettings.pageSize, take: grid.pageSettings.pageSize };
        this.fetchData(state);
      })
    },
    // Retire les doublons dans un tableau
    arrayUnique(array) {
      var a = array.concat();
      for(var i=0; i<a.length; ++i) {
        for(var j=i+1; j<a.length; ++j) {
          if(a[i] === a[j])
            a.splice(j--, 1);
        }
      }

      return a;
    }
  }
}
</script>

<style lang="scss">

.square-disabled {
  cursor: not-allowed;
}

.command-datagrid .command-state-loading,
.command-datagrid .command-state-loading:disabled {
  cursor: wait !important;
  opacity: 1 !important;
}

.command-datagrid .command-state-loading .fa-circle-notch {
  color: #f96332;
  font-size: 13px;
}

.half-prepared {
  background: repeating-linear-gradient(
          145deg,
          #92c9f9 ,
          #92c9f9  10px,
          #ffffff 10px,
          #ffffff 60px
  );
}

.actionPopup {
  border: 1px solid rgb(219, 219, 231);
  border-radius: 5px;
  box-shadow: 4px 4px 5px rgb(224, 224, 224);
  width: fit-content;
  padding: 5px;
  display: none;
  position: fixed;
  z-index: 12;
  background-color: #fff;
}

.actionList {
  padding: 0;
  margin: 0;
}

.actionListItem {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.e-btn {
  text-decoration: initial;
}
.modal-footer{
  margin: auto !important;
}

.resizing {
  resize: none;
  border-radius: 11px;
  border-color: #e3e3e3;
  padding: 8px;
}

.resizing:focus-visible {
  outline: -webkit-focus-ring-color auto 0px !important;
  border: 1px solid #b7b7b7 !important;
}

@media (min-width: 576px){
  .modal-dialog {
    max-width: 500px;
    margin: 15% auto !important;
  }
}


.e-btn.e-flat, .e-css.e-btn.e-flat {
  color: rgb(36 72 113) !important;
}

.MySearch{
  margin-right: 5px;
  width: 200px;
  display: inline-flex;
}
.e-detailindentcell {
  display: none;
}
.command-datagrid > .e-popup-open {
  top: -34px !important;
  left: unset !important;
  right: 3% !important;
}

.command-datagrid {

  &.e-grid .e-pager {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;

    .e-pagesizes {
      position: absolute;
      left: 0;
      bottom: 5px;

      .e-pagerdropdown {
        border: solid 1px #e0e0e0;
        border-radius: 7px;

        .e-dropdownlist {
          text-align: center;
        }

        .e-input-group-icon {
          margin-right: 6px !important;
        }
      }

      .e-pagerconstant {
        margin: 0 0 5px 7px;
      }
    }

    .e-currentitem, .e-currentitem:hover {
      background-color: #f96332;
    }

    .e-icons.e-pager-default {
      color: #f96332;
    }
  }
}

.e-dropdownbase .e-list-item.e-active, .e-dropdownbase .e-list-item.e-active:hover {
  color: #f96332;
}

@media screen and (max-width: 770px) {
  .command-datagrid.e-grid .e-pagesizes{
    display: none;
  }
}

@media screen and (min-width: 993px) {
  .command-datagrid.e-grid .e-pager{
    text-align: center;
  }
}
</style>
